import React, { useState } from 'react';
import { Button } from '../../../../components/ui';
import { Modal } from 'antd';
import CSVWarning from '../../FormFields/CSVWarning';

type Props = {
  result: {
    valid: boolean,
    errors: { row: number, message: string }[],
    totalRows: number,
    message: string,
  },
  isWarningOnly: boolean,
};

export default function CsvErrorButton({ result, isWarningOnly }: Props) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button onClick={() => setShowModal(true)}>
        {isWarningOnly ? `Show Warning(s)` : `Show Error(s)`}
      </Button>
      <Modal
        title={result.message}
        visible={showModal}
        onCancel={() => setShowModal(false)}
      >
        <CSVWarning data={result} />
      </Modal>
    </>
  );
}
